import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { ThreatConsole } from './console/ThreatConsole';
import { supportEmail } from '../data/site';
export function Hero() {
  return <section id="top" className="relative overflow-hidden" aria-labelledby="hero-heading" data-id="element-121" data-mp="9lbgj25n3de4">
      <div aria-hidden="true" className="bg-blueprint pointer-events-none absolute inset-0" data-id="element-122" data-mp="4n1jem0cu2pv" />
      <div aria-hidden="true" className="ambient-glow pointer-events-none absolute -right-40 -top-52 h-[700px] w-[700px]" data-id="element-123" data-mp="128607wumu8qj" />

      <div className="relative mx-auto flex w-full max-w-[1440px] flex-col items-start gap-16 px-6 py-16 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:px-16 lg:py-24" data-id="element-124" data-mp="x8jj3cboo8cg">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[560px] flex-col items-start" data-id="element-125" data-mp="neax77h5rdn9">
          <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent/25 bg-accent/[0.07] px-3.5 py-1.5 text-xs font-semibold tracking-[0.02em] text-accent-quiet" data-id="element-126" data-mp="3j7zc59vbxccg">
            <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent-ink" data-id="element-127" data-mp="39al869qleg11" />
            UN R155 / ISO 21434 aligned
          </p>

          <h1 id="hero-heading" className="mb-5 text-[40px] font-extrabold leading-[1.12] tracking-tightest text-heading sm:text-[44px]" data-id="element-128" data-mp="3e7uvnjuf8hm8">
            The Leading <span className="text-accent-ink" data-id="element-129" data-mp="359j9pv4i2804">Autonomous Vehicle</span> Security
            Platform
          </h1>

          <p className="mb-7 max-w-[490px] text-base leading-[1.62] text-muted" data-id="element-130" data-mp="2qlepuntpnqfr">
            Advanced AI-driven cybersecurity solutions to protect self-driving cars and automated
            vehicles from cyber threats.
          </p>

          <div className="mb-8 flex flex-wrap items-center gap-4" data-id="element-131" data-mp="2lkqyg11kl7l0">
            <a href={`mailto:${supportEmail}?subject=Ziaxen%20demo%20request`} className="shadow-accent rounded-[10px] border border-accent bg-accent px-6 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:border-accent-hover hover:bg-accent-hover" data-id="element-132" data-mp="2ljz22o05f5to">
              Request a demo
            </a>
            <a href="#platform" className="inline-flex items-center gap-2 rounded-[10px] border border-line px-6 py-3 text-[15px] font-semibold text-heading transition-colors duration-150 ease-out hover:border-accent/60" data-id="element-133" data-mp="de6n8os9pxjq">
              See the platform
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="111ol9224lrv5" />
            </a>
          </div>

          <div className="flex w-full items-center gap-2.5 border-t border-line pt-5" data-id="element-135" data-mp="x031qxv36fbz">
            <span aria-hidden="true" className="flex h-5 w-5 shrink-0 items-center justify-center rounded-[5px] border border-accent/30 bg-accent/10" data-id="element-136" data-mp="3lt756pxsnptq">
              <CheckIcon className="h-3 w-3 text-accent-ink" data-id="element-137" data-mp="1x9ujo7n357lu" />
            </span>
            <p className="text-[13px] font-medium text-muted" data-id="element-138" data-mp="21amwtbz2vwne">
              Certified aligned with UN R155 / ISO 21434 automotive cybersecurity standards
            </p>
          </div>
        </motion.div>

        <div className="flex w-full justify-center lg:block lg:w-auto lg:shrink-0" data-id="element-139" data-mp="2b0fynl9f4xeg">
          <ThreatConsole data-id="element-140" data-mp="2fzss4ousp2q0" />
        </div>
      </div>
    </section>;
}